import { config } from "src/stateManagement/redux/configVar";
import { formatDateToYYYYMMDD } from "./formatDates";
import { toast } from "react-toastify";

export const getDailySummaryReportAlone = async (reportId: string, reportCode: string, startDate: Date | string, endDate: Date | string, projectId: string) => {
    try {

        const serverUrl = config.serverUrl

        let token = localStorage.getItem("authToken");

        if (!token) {
            return;
        }


        const headers: any = {
            "Content-Type": "application/json",
            authorization: `${token}`,
            report_id: reportId,
            report_code: reportCode,
            start_date: formatDateToYYYYMMDD(startDate),
            end_date: formatDateToYYYYMMDD(endDate),
        }

        if (projectId) {
            headers["project_id"] = projectId;
        }


        const response = await fetch(`${serverUrl}/api/reports/getDailySummaryReport`, {
            method: "GET",
            headers
        });


        if (response?.status === 401) {
            return;
        }

        if (response?.status !== 200 && response?.status !== 201) {
            return;
        }

        const data = await response.json();

        return data;
    } catch (error) {
        console.log({ error });
    }
}

export const getTaskDataByid = async (taskId: string) => {
    try {

        const serverUrl = config.serverUrl

        let token = localStorage.getItem("authToken");

        if (!token) {
            return;
        }


        const headers: any = {
            "Content-Type": "application/json",
            authorization: `${token}`,
            planningActivityId: taskId
        }

        const response = await fetch(`${serverUrl}/api/planning/getPlanningActivityById`, {
            method: "GET",
            headers
        });


        if (response?.status === 401) {
            return;
        }

        if (response?.status !== 200 && response?.status !== 201) {
            return;
        }

        const data = await response.json();

        return data;
    } catch (error) {
        console.log({ error });
    }
}

export const getListOfUsers = async () => {
    try {

        const serverUrl = config.serverUrl

        let token = localStorage.getItem("authToken");

        if (!token) {
            return;
        }

        const headers: any = {
            "Content-Type": "application/json",
            authorization: `${token}`,
        }

        const response = await fetch(`${serverUrl}/api/shared/listOfUsers`, {
            method: "GET",
            headers
        });

        if (response?.status === 401) {
            return;
        }

        if (response?.status !== 200 && response?.status !== 201) {
            return;
        }

        const data = await response.json();

        return data;
    } catch (error) {
        console.log({ error });
    }
}

export const getListForConfigTask = async () => {
    try {

        const serverUrl = config.serverUrl

        let token = localStorage.getItem("authToken");

        if (!token) {
            return;
        }

        const headers: any = {
            "Content-Type": "application/json",
            authorization: `${token}`,
        }

        const response = await fetch(`${serverUrl}/api/shared/getListForPlanningTask`, {
            method: "GET",
            headers
        });

        if (response?.status === 401) {
            return;
        }

        if (response?.status !== 200 && response?.status !== 201) {
            return;
        }

        const data = await response.json();

        return data;
    } catch (error) {
        console.log({ error });
    }
}

export const getListOfLocationsByProject = async (projectId?: string) => {
    try {

        const serverUrl = config.serverUrl

        let token = localStorage.getItem("authToken");

        if (!token) {
            return;
        }

        const headers: any = {
            "Content-Type": "application/json",
            authorization: `${token}`,
        }

        if (projectId) {
            headers["projectId"] = projectId;
        }

        const response = await fetch(`${serverUrl}/api/projects/getLocations`, {
            method: "GET",
            headers
        });

        if (response?.status === 401) {
            return;
        }

        if (response?.status !== 200 && response?.status !== 201) {
            return;
        }

        const data = await response.json();

        return data;
    } catch (error) {
        console.log({ error });
    }
}

export const getOriginFlowByModule = async (module: string) => {
    try {

        const serverUrl = config.serverUrl

        let token = localStorage.getItem("authToken");

        if (!token) {
            return;
        }

        const headers: any = {
            "Content-Type": "application/json",
            authorization: `${token}`,
            uploadModule: module,
        }

        const response = await fetch(`${serverUrl}/api/shared/getOriginFlowByUploadModule`, {
            method: "GET",
            headers
        });

        if (response?.status === 401) {
            return;
        }

        if (response?.status !== 200 && response?.status !== 201) {
            return;
        }

        const data = await response.json();

        return data;
    } catch (error) {
        console.log({ error });
    }
}

export const getFormValidations = async (code: string, fromModuleVersion: string) => {
    try {

        const serverUrl = config.serverUrl

        let token = localStorage.getItem("authToken");

        if (!token) {
            return;
        }

        const headers: any = {
            "Content-Type": "application/json",
            authorization: `${token}`,
            formCode: code,
            fromModuleVersion,
        }

        const response = await fetch(`${serverUrl}/api/shared/getFormValidations`, {
            method: "GET",
            headers
        });

        if (response?.status === 401) {
            return;
        }

        if (response?.status !== 200 && response?.status !== 201) {
            return;
        }

        const data = await response.json();

        return data;
    } catch (error) {
        console.log({ error });
    }
}

export const getGroupAssignedConfig = async () => {
    try {

        const serverUrl = config.serverUrl

        let token = localStorage.getItem("authToken");

        if (!token) {
            return;
        }

        const headers: any = {
            "Content-Type": "application/json",
            authorization: `${token}`,
        }

        const response = await fetch(`${serverUrl}/api/shared/getGroupAssignedConfig`, {
            method: "GET",
            headers
        });

        if (response?.status === 401) {
            return;
        }

        if (response?.status !== 200 && response?.status !== 201) {
            return;
        }

        const data = await response.json();

        return data;
    } catch (error) {
        console.log({ error });
    }
}

export const getPendingRequirementsByDate = async (startDate: Date | string, endDate: Date | string, projectId?: string) => {
    try {

        const serverUrl = config.serverUrl

        let token = localStorage.getItem("authToken");

        if (!token) {
            return;
        }

        const headers: any = {
            "Content-Type": "application/json",
            authorization: `${token}`,
            start_date: formatDateToYYYYMMDD(startDate),
            end_date: formatDateToYYYYMMDD(endDate),
        }

        if (projectId) {
            headers["project_id"] = projectId;
        }


        const response = await fetch(`${serverUrl}/api/reports/getActivesRequirementsReport`, {
            method: "GET",
            headers
        });


        if (response?.status === 401) {
            return;
        }

        if (response?.status !== 200 && response?.status !== 201) {
            return;
        }

        const data = await response.json();

        return data;
    } catch (error) {
        console.log({ error });
    }
}

export const getAnalyzedByDate = async (startDate: Date | string, endDate: Date | string, projectId?: string) => {
    try {

        const serverUrl = config.serverUrl

        let token = localStorage.getItem("authToken");

        if (!token) {
            return;
        }

        const headers: any = {
            "Content-Type": "application/json",
            authorization: `${token}`,
            start_date: formatDateToYYYYMMDD(startDate),
            end_date: formatDateToYYYYMMDD(endDate),
        }

        if (projectId) {
            headers["project_id"] = projectId;
        }


        const response = await fetch(`${serverUrl}/api/reports/getAnalysisReport`, {
            method: "GET",
            headers
        });


        if (response?.status === 401) {
            return;
        }

        if (response?.status !== 200 && response?.status !== 201) {
            return;
        }

        const data = await response.json();

        return data;
    } catch (error) {
        console.log({ error });
    }
}

export const getDashboardDataProfileByMethod = async (method?: string) => {
    try {

        const serverUrl = config.serverUrl

        let token = localStorage.getItem("authToken");

        if (!token) {
            return;
        }

        const headers: any = {
            "Content-Type": "application/json",
            authorization: `${token}`,
            method,
        }

        const response = await fetch(`${serverUrl}/api/operations/getAllDashboardProfilesByMethod`, {
            method: "GET",
            headers
        });


        if (response?.status === 401) {
            return;
        }

        if (response?.status !== 200 && response?.status !== 201) {
            return;
        }

        const data = await response.json();

        return data;
    } catch (error) {
        console.log({ error });
    }
}

export const getTagList = async () => {

    try {

        const serverUrl = config.serverUrl

        let token = localStorage.getItem("authToken");

        if (!token) {
            return;
        }

        const response = await fetch(
            `${serverUrl}/api/configuration/get-tags-list`,
            {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    authorization: `${token}`,
                },
            }
        );

        if (response?.status === 401) {
            return;
        }

        if (response?.status !== 200 && response?.status !== 201) {
            return;
        }

        const data = await response.json();

        return data;

    } catch (error) {
        console.log({ error });
    }


}

export const getTagLgetListOfOptimizationActivities = async (body: any) => {

    try {

        const serverUrl = config.serverUrl

        let token = localStorage.getItem("authToken");

        if (!token) {
            return;
        }

        const response = await fetch(
            `${serverUrl}/api/operations/getListOfOptimizationActivities`,
            {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    authorization: `${token}`,
                },
                body: JSON.stringify(body)
            }
        );

        if (response?.status === 401) {
            return;
        }

        if (response?.status !== 200 && response?.status !== 201) {
            return;
        }

        const data = await response.json();

        return data;

    } catch (error) {
        console.log({ error });
    }


}

export const getTagLgetListOfOptimizationActivitiesInExcel = async (body: any) => {

    try {

        const serverUrl = config.serverUrl

        let token = localStorage.getItem("authToken");

        if (!token) {
            return;
        }

        const response = await fetch(
            `${serverUrl}/api/operations/getListOfOptimizationActivitiesInExcel`,
            {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    authorization: `${token}`,
                },
                body: JSON.stringify(body)
            }
        );

        if (response?.status === 401) {
            return;
        }

        if (response?.status !== 200 && response?.status !== 201) {
            return;
        }

        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;


        const contentDisposition = response.headers.get(
            "Content-Disposition"
        );

        if (contentDisposition) {
            a.download =
                contentDisposition.split("filename=")[1];
        }
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);

    } catch (error) {
        console.log({ error });
    }


}


export const getPlanningActivitiesForDates = async (startDate: string, endDate: string, type: string) => {

    try {

        const serverUrl = config.serverUrl

        let token = localStorage.getItem("authToken");

        if (!token) {
            return;
        }

        const response = await fetch(
            `${serverUrl}/api/planning/getPlannedActivitiesByDateRangeAndType`,
            {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    authorization: `${token}`,
                    "startDate": startDate,
                    "endDate": endDate,
                    "type": type
                },
            }
        );

        if (response?.status === 401) {
            return;
        }

        if (response?.status !== 200 && response?.status !== 201) {
            return;
        }

        const data = await response.json();

        return data;

    } catch (error) {
        console.log({ error });
    }


}

export const getAnalystReport = async (startDate: string, endDate: string) => {

    try {

        const serverUrl = config.serverUrl

        let token = localStorage.getItem("authToken");

        if (!token) {
            return;
        }

        const response = await fetch(
            `${serverUrl}/api/reports/getAnalysisReport`,
            {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    authorization: `${token}`,
                    "start_date": startDate,
                    "end_date": endDate,
                },
            }
        );

        if (response?.status === 401) {
            return;
        }

        if (response?.status !== 200 && response?.status !== 201) {
            return;
        }

        const data = await response.json();

        return data;

    } catch (error) {
        console.log({ error });
    }


}

export const getFilePreview = async (fileId: string) => {

    try {

        const serverUrl = config.serverUrl

        let token = localStorage.getItem("authToken");

        if (!token) {
            return;
        }

        const response = await fetch(
            `${serverUrl}/api/shared/getFile`,
            {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    authorization: `${token}`,
                    "fileId": fileId
                },
            }
        );

        if (response?.status === 401) {
            toast.error("Error al cargar el archivo");
            return;
        }

        if (response?.status !== 200 && response?.status !== 201) {
            toast.error("Error al cargar el archivo");
            return;
        }

        const data = await response.json();

        return data;

    } catch (error) {
        console.log({ error });
    }
}

export const getOperationsAdvanceReport = async (
    startDate: string,
    endDate: string,
    typeOfSearch: string,
    responseFormat: "summaryCards" | "activitiesList" | "",
    locations?: string
) => {

    try {

        const serverUrl = config.serverUrl

        let token = localStorage.getItem("authToken");

        if (!token) {
            return;
        }

        const headers: any = {
            "Content-Type": "application/json",
            authorization: `${token}`,
            "start_date": startDate,
            "end_date": endDate,
            "type_of_search": typeOfSearch,
            responseFormat
        };

        // Agregar locations solo si está presente
        if (locations && locations.trim() !== '') {
            headers["locations"] = locations;
        }

        const response = await fetch(
            `${serverUrl}/api/reports/getOperationsAdvanceReport`,
            {
                method: "GET",
                headers,
            }
        );

        const data = await response.json();

        return {
            responseStatus: response.ok,
            data
        };

    } catch (error) {
        console.log({ error });
    }


}

export const downloadLargeNumberOfFilesAndSendByEmail = async (
    fileKeys: string[],
    recipientEmail: string
) => {
    try {
        const serverUrl = config.serverUrl;
        let token = localStorage.getItem("authToken");

        if (!token) {
            return;
        }

        const response = await fetch(
            `${serverUrl}/api/shared/downloadLargeNumberOfFilesAndSendByEmail`,
            {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    authorization: `${token}`,
                    "fileKeys": JSON.stringify(fileKeys),
                    "recipientEmail": recipientEmail,
                },
            }
        );

        const data = await response.json();

        return {
            responseStatus: response.ok,
            data
        };

    } catch (error) {
        console.log({ error });
    }
}